<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="商品编码" prop="goodsCode">
            <el-input v-model="searchForm.goodsCode" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model="searchForm.goodsName" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="更新人员" prop="updatedBy">
            <el-input v-model="searchForm.updatedBy" clearable @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="更新时间">
            <form-date-range
              :form="searchForm"
              startKey="updatedDateStart"
              :usingTime="false"
              endKey="updatedDateEnd"
              valueFormat="yyyyMMdd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button class="green-btn" size="small" @click="exportExcel">导出</el-button>
        <el-button class="orange-btn" size="small" @click="importExcel">导入</el-button>
        <el-button class="green-btn" size="small" @click="addLivePrice(0)">新增</el-button>
        <el-button class="orange-btn" size="small" @click="addLivePrice(1)" v-permission="`ec-pc-new#ec-pc-new#specialLiveManage#specialAdd`">特殊申请</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="goodsCode" label="商品编码" min-width="120"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="livePrice" label="直播价" min-width="80" align="center"></el-table-column>
        <el-table-column prop="liveRebate" label="直播佣金" min-width="80" align="center"></el-table-column>
        <el-table-column prop="authorName" label="达人名称" min-width="100" align="center"></el-table-column>
        <el-table-column prop="liveDate" label="直播时间" min-width="150" align="center"></el-table-column>
        <el-table-column prop="updatedBy" label="更新人员" min-width="80" align="center"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" min-width="150" align="center"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <add-dialog :visible.sync="addVisible" :boolSpecial="boolSpecial" v-if="addVisible" @success="onSearch"/>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import addDialog from './components/add-dialog';
export default {
  name: 'livePriceUphold',
  mixins: [tableMixin, pagePathMixin],
  components: {addDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      imgFormVisible: false,
      addVisible: false,
      searchFormData: [],
      selectionData: [],
      rules: {},
      storeList: [],
      loading: false,
      searchForm: {
        goodsCode: '',
        goodsName: '',
        updatedBy: '',
        updatedDateStart: '',
        updatedDateEnd: '',
      },
      rowData: {},
      boolSpecial: 0,
    };
  },
  computed: {},
  mounted() {
    let query = this.$route.query;
    if (query.goodsCode) {
      this.searchForm = {
        ...this.searchForm,
        ...query,
      }
    }
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let { updatedDateStart, updatedDateEnd } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          updatedDateStart: updatedDateStart ? updatedDateStart + ' 00:00:00' : '',
          updatedDateEnd: updatedDateEnd ? updatedDateEnd + ' 23:59:59' : '',
        },
      };
      this.searchFormData = data;
      this.$q.goods
        .goodsLivePricePage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    // 新增申请
    addLivePrice(type) {
      this.boolSpecial = type
      this.addVisible = true;
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: '/goods/livePriceUpholdImport',
        query: {
          fileName: '商品直播价导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'authorGoodsLivePriceImport',
        },
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'goodsLivePricePage',
      };
      this.$q.common
        .exportExcel({ data: params })
        .then(res => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(_ => {
          loading.close();
        });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}
</style>
